import { ACRE, CELL_SIZE, type LatLng, type PermitLabel } from '../model'

export function floorLatLng({ latitude, longitude }: LatLng): LatLng {
  return {
    latitude: floor(latitude, CELL_SIZE),
    longitude: floor(longitude, CELL_SIZE),
  }
}

export function floor(valueStr: number | string, cellSize = 1): number {
  const value = getFloat(valueStr)
  if (cellSize <= 0) throw new Error('floor: cellSize must be a positive number')
  const factor = 1 / cellSize
  const floatingPointError = 0.000001
  const rounded = Math.floor((value + floatingPointError) * factor) / factor
  return rounded
}

function getFloat(value: number | string): number {
  if (typeof value === 'string') {
    return Number.parseFloat(value)
  }
  return value
}

export function sqftToAcres(sqft: number): number {
  return sqft / ACRE
}

export const stringifyPermitLabel = (label: PermitLabel): string => {
  switch (label) {
    case 'other':
      return 'Other'
    case 'accessory_dwelling_unit':
      return 'Accessory Dwelling Unit (ADU)'
    case 'electric_vehicle_charger':
      return 'EV Charger'
    case 'electric_water_heater':
      return 'Electric Water Heater'
    case 'electrical_panel_upgrade':
      return 'Main Panel Upgrade'
    case 'home_addition':
      return 'Home Addition'
    case 'hvac_changeout':
      return 'HVAC System'
    case 'pool':
      return 'Pool'
    case 'roof':
      return 'Roof'
    case 'solar':
      return 'Solar'
    case 'spa_sauna':
      return 'Spa/Sauna/Hot Tub'
  }
}

export function buildBoundingBox(latlng: LatLng): { minLat: number; maxLat: number; minLng: number; maxLng: number } {
  return {
    minLat: latlng.latitude,
    maxLat: latlng.latitude + CELL_SIZE,
    minLng: latlng.longitude,
    maxLng: latlng.longitude + CELL_SIZE,
  }
}
